module.exports = __webpack_public_path__ + "img/1499795642.3a014104.jpg";